import { useContext, useRef } from "react";
import { useContent } from "src/shared/components/content";
import { LocationContext } from "src/shared/context/location-context";
import { CarouselGenreFilter } from "src/website-apps/responsive/stubhub-home/components/tm-home-move-filters-out-of-header/CarouselGenreFilter";
import { VerticalBar } from "src/website-apps/responsive/stubhub-home/components/tm-home-move-filters-out-of-header/CarouselGenreFilter.styled";
import { DateSelector } from "src/website-apps/shared/components/date-selector";
import { HorizontalScrollingBlurContainer } from "src/website-apps/shared/components/HorizontalScrollingBlurContainer";
import { LocationSelector } from "src/website-apps/shared/components/location-selector";
import { DateContext } from "src/website-apps/shared/context/date-context";
import { Container, filterContainer, RowLayout } from "./PageFiltersOnHome.styled";

export const PageFiltersOnHome = ({ selectedCarouselGenre, setSelectedCarouselGenre }) => {
  const [userLocation, setUserLocation] = useContext(LocationContext);
  const [dates, setDates] = useContext(DateContext);
  const scrollerRef = useRef(null);
  const locationSelectorPlaceholderContent = useContent("cid$#1904153#");

  return (
    <RowLayout>
      <Container>
        <HorizontalScrollingBlurContainer scrollerRef={scrollerRef}>
          <div className={filterContainer} ref={scrollerRef}>
            {/* Filters are wrapped in divs to work around the inlined drawer.
        We should consider "portaling" the drawer to prevent layout shift. */}
            <div>
              <LocationSelector
                placeholder={locationSelectorPlaceholderContent}
                location={userLocation}
                redesign
                onLocationChange={setUserLocation}
                applied
              />
            </div>
            <div>
              <DateSelector dates={dates} redesign onDatesChange={setDates} addActiveState />
            </div>
          </div>
        </HorizontalScrollingBlurContainer>
      </Container>

      <VerticalBar />
      <CarouselGenreFilter selectedTlc={selectedCarouselGenre} setSelectedTlc={setSelectedCarouselGenre} />
    </RowLayout>
  );
};
